import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DealActivityService {

  url = environment.serverAPI9 + "/api/dealActivity";

  url1 = environment.serverAPI9 + "/api/makeCall";

  url3 = environment.serverAPI9 + "/api";

  url2 = environment.serverAPI9 + "/api/smartView";

  url4 = environment.serverAPI9 + "/api/deal";

  constructor(private http: HttpClient) { }

  getAllDealActivity(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  dealActivityActivity(Page: any, size: any, sort: any): Observable<Object> {
    return this.getAllDealActivity(Page, size, sort);
  }

  getAllDealActivityDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  dealActivityActivityDropDown(): Observable<Object> {
    return this.getAllDealActivityDropDown();
  }

  getDealActivityById(dealId: number): Observable<Object> {
    return this.http.get(`${this.url}/${dealId}`);
  }

  addOrEditDealActivity(dealActivity: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, dealActivity);
  }


  dealActivitySearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  DealActivitySearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.dealActivitySearch(query, Page, size, sort);
  }

  getAllDealActivityBydealId(dealId: number): Observable<Object> {
    return this.http.get(`${this.url}/New/deal/${dealId}`);
  }

  dealActivityBydealId(dealId: number): Observable<Object> {
    return this.getAllDealActivityBydealId(dealId);
  }

  dealActivityByDealId(dealId: number): Observable<Object> {
    return this.getAllDealActivityBydealId(dealId);
  }

  deleteByDealActivityId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  deleteBydealActivityId(id: any): Observable<Object> {
    return this.deleteByDealActivityId(id);
  }

  makeCall(dealId: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}`, dealId);
  }

  makeDooctiClickToCall(deal): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall`, deal);
  }

  makeTelecmi(deal): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/telecmi`, deal);
  }

  callForBuzzDieal(deal): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/buzzdial`, deal);
  }

  calltoElevenlabs(deal): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/elevenlabs`, deal);
  }

  clickToCallAcefone(acefone): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/acefone`, acefone);
  }

  getBrandDataByMonthAndYear(brand: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/details/month`, brand);
  }

  searchActivityFilter(query: string, page: number, size: number, sort: string, additionalQuery: any): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,
      "additionalQuery": additionalQuery
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;
    return this.http.post<Response[]>(`${this.url2}/condition/advanced${queryParams}`, requestBody);
  }

  searchDealAdvanceFilter(query: string, page: number, size: number, sort: string, additionalQuery: any): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,
      "additionalQuery": additionalQuery
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;
    return this.http.post<Response[]>(`${this.url4}/advanced/filter${queryParams}`, requestBody);
  }

  searchDealAdvanceFilterNew(query: string, page: number, size: number, sort: string, additionalQuery: any): Observable<Response[]> {
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;
    return this.http.post<Response[]>(`${this.url4}/advanced/filter/new${queryParams}`, additionalQuery);
  }

  searchAllActivity(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;
    return this.http.post<Response[]>(`${this.url}/filter/advanced${queryParams}`, requestBody);
  }

  getAllDealActivityByPageable(Page: any, size: any, sort: any, dealId: any, taskType: any): Observable<Object> {
    return this.http.get(`${this.url}/New/deal/taskType/${dealId}/${taskType}?page=${Page}&size=${size}&sort=${sort}`);
  }

  dealActivityByPageable(Page: any, size: any, sort: any, dealId: any, taskType: any): Observable<Object> {
    return this.getAllDealActivityByPageable(Page, size, sort, dealId, taskType);
  }

  sendWebToMobileCall(deal: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/trigerCall`, deal);
  }

}
